import React, { useState, useEffect, useLayoutEffect } from 'react'
import { navigate } from 'gatsby'
import Layout from '../../templates/Master'
import PageBuilder from '../../views/pageBuilder'
import Loader from '../../components/loaders/PageLoader'
import ProductDetails from '../../templates/ProductDetails'
import { connect } from 'react-redux'
import {
    onSnapshot,
    query as fsQuery,
    collection,
    doc,
    where,
} from 'firebase/firestore'
import { db } from '../../system/firebase/index'
import { dialogState } from '../../system/redux/reducers/dialog'
import { previewState } from '../../system/redux/reducers/preview'

const Page = ({
    dispatch,
    location,
    isAuthenticated,
    isVerifying,
    verificationComplete,
    params,
}) => {
    const fallback = <Loader />
    const [pageData, setPageData] = useState(false)
    const queryParams = new URLSearchParams(location.search)
    const id = queryParams.get('id')

    useEffect(() => {
        if (location.search) {
            if (
                queryParams.get('preview') === 'true' &&
                queryParams.get('id')
            ) {
                dispatch(previewState(queryParams.get('id')))
            }
        }
    }, [location, isVerifying, isAuthenticated, verificationComplete])

    useLayoutEffect(() => {
        let isCancelled = false
        let single = false
        let q = fsQuery(
            collection(db, 'collectionSearch'),
            where('slug', '==', params.slug),
            where('visibility', '!=', 'draft')
        )
        if (id) {
            q = doc(db, 'collectionSearch', id)
            single = true
        }
        onSnapshot(q, (snapshot) => {
            if (isCancelled) {
                return
            }
            const output = []
            if (single) {
                if (snapshot.exists()) {
                    const data = snapshot.data()
                    if (
                        !isVerifying &&
                        !isAuthenticated &&
                        verificationComplete &&
                        (data.visibility === 'draft' || !data.profileActive)
                    ) {
                        dispatch(
                            dialogState(
                                JSON.stringify({ open: true, id: 'LOGIN' })
                            )
                        )
                    } else {
                        output.push(data)
                    }
                }
            } else {
                if (snapshot.empty) {
                    navigate('/404/')
                }
                snapshot.forEach((doc) => {
                    output.push(doc.data())
                })
            }

            setPageData(output[0])
        })
        return () => {
            isCancelled = true
        }
    }, [id, verificationComplete])

    return (
        <Layout
            location={location}
            pageTitle={pageData?.title}
        >
            {pageData ? (
                pageData.content?.modules && Array.isArray(pageData.content?.modules) && pageData.content?.modules.length ? (
                    <PageBuilder
                        dataFallback={fallback}
                        data={pageData}
                        id={pageData.slug}
                    />
                ) : (
                    <ProductDetails data={pageData} />
                )
            ) : (
                <Loader />
            )}
        </Layout>
    )
}
function mapStateToProps(state) {
    return {
        isAuthenticated: state.Auth.isAuthenticated,
        isVerifying: state.Auth.isVerifying,
        verificationComplete: state.Auth.verificationComplete,
    }
}

export default connect(mapStateToProps)(Page)
